import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';

class ForecastedAccountBalance extends DomainObject {
  used;
  available;
  scheduled;
  workDayLength;
  unlimited;
  typeUnit;

  constructor(other) {
    super();

    makeObservable(this, {
      used: observable,
      available: observable,
      scheduled: observable,
      workDayLength: observable,
      unlimited: observable,
      typeUnit: observable,
      usedDaysOrHours: computed,
      scheduledDaysOrHours: computed,
      availableDaysOrHours: computed,
      secondsPerUnit: computed
    });

    this.merge(other);
  }

  get usedDaysOrHours() {
    return Math.round(this.used * 100 / this.secondsPerUnit) / 100;
  }

  get scheduledDaysOrHours() {
    return Math.round(this.scheduled * 100 / this.secondsPerUnit) / 100;
  }

  get availableDaysOrHours() {
    return Math.round(this.available * 100 / this.secondsPerUnit) / 100;
  }

  get secondsPerUnit() {
    if (this.typeUnit === 'days') {
      return this.workDayLength;
    } else if (this.typeUnit === 'hours') {
      return 3600;
    } else {
      throw new Error(`Unrecognized type unit ${this.typeUnit} in forecasted balance`);
    }
  }
}

export default ForecastedAccountBalance;
